import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../Images';
import Card from './Card';
import LockedContent from '../../components/LockedContent';
import DashboardButton from '../../pages/Dashboard/DashboardButton';

const DashboardImageCard = ({
  title,
  footer,
  image,
  locked,
  onButtonClick,
}) => (
  <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <LockedContent locked={locked}>
        <a href={image.link}>
          <ResponsiveImage src={image.src} alt={image.alt} />
        </a>
      </LockedContent>
    </Card.Body>
    <Card.Footer>
      <DashboardButton
        onClickLocked={onButtonClick}
        locked={locked}
        href={footer.buttonLink}
        secondary
        my0
      >
        {footer.buttonText}
      </DashboardButton>
    </Card.Footer>
  </Card>
);

DashboardImageCard.propTypes = {
  locked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  image: PropTypes.exact({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
  footer: PropTypes.exact({
    buttonLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
  }).isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

DashboardImageCard.defaultProps = {
  locked: false,
};

export default DashboardImageCard;
